import axios from 'axios'
import { ref } from 'vue'
import { APIS_TOPOLOGY, TIMEOUTTIME } from '@/constants/apis'
import { showConsoleError } from '@/functions/errors'
import { TOKEN } from '@/constants/labels'
import { ARRAY_PARAMETROS, EQUIPOS, CLIENT_STATUS_TABLE } from '@/interfaces/SmartLink/Equipos'


export async function getClientStatusData() {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_TOPOLOGY.value.getClientStatusData, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: EQUIPOS[] = response.data;
      const finalObj = ref({})
      const showGraphs = ref(finalData.length > 0)
      const maxCount = ref(0)
      if (finalData.length > 0) {
        const grouped: Record<string, CLIENT_STATUS_TABLE> = finalData.reduce((acc: Record<string, CLIENT_STATUS_TABLE>, item: EQUIPOS) => {

          const id = item.name ? item.name.split("-")[0] : 'finalID';

          if (!acc[id]) {
            acc[id] = { id };
          }

          const count = Object.keys(acc[id]).filter(k => k.startsWith("ip")).length + 1;

          if (count > maxCount.value) maxCount.value = count

          acc[id][`ip${count}`] = item.ip ?? '';
          acc[id][`latencia${count}`] = item.latencia ?? -1;
          acc[id][`fecha${count}`] = item.fecha ?? '';
          acc[id][`nombre${count}`] = item.name ?? '';
          acc[id][`radio${count}`] = `${item.name} - ${item.ip}`;
          acc[id][`estado${count}`] = item.latencia ?? -1;


          return acc;
        }, {});


        const result = Object.values(grouped);
        finalObj.value = {
          allArrays: result,
          maxCount
        }
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}

export async function getClientStatusDataByIPS(params: ARRAY_PARAMETROS) {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_TOPOLOGY.value.getClientStatusDataByIPS, { params: params, timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: EQUIPOS[] = response.data;
      const finalObj = ref({
        allData: [[[0, 0]]],
        allName: ['']
      })
      const showGraphs = ref(finalData.length > 0)
      if (finalData.length > 0) {
        const grouped = finalData.reduce((acc: Record<string, number[][]>, item: EQUIPOS) => {
          // Extraemos el identificador (parte antes del primer guion)

          const tiempo = new Date(item.fecha ?? '');
          const milliseconds = tiempo.getTime();

          const id = item.ip ? item.ip : '000.000.000.000';

          if (!acc[id]) {
            acc[id] = []; // Puedes cambiar "id" por "name" si prefieres
          }
          // const status = getStatus(item.latencia ?? 0)
          acc[id].push([milliseconds, item.latencia ?? 0])
          // if (status.toUpperCase() === STATUS.ok) { acc[id].push([milliseconds, 3]) }
          // if (status.toUpperCase() === STATUS.alert) { acc[id].push([milliseconds, 2]) }
          // if (status.toUpperCase() === STATUS.alarm) { acc[id].push([milliseconds, 1]) }
          // if (status.toUpperCase() === STATUS.down) { acc[id].push([milliseconds, 0.2]) }



          return acc;
        }, {});
        const allData = Object.values(grouped);
        const allName = Object.keys(grouped)

        finalObj.value = {
          allData,
          allName
        }
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}

